<template>
    <article class="mobile__payment-header container--row">
        <figure>
            <!-- <img
                :src="require('@/assets/icons/' + logo + '.svg')"
                :alt="`${logo} 'icon'`"
            /> -->
            <button :class="closeClass" type="button" @click="goBack">
                <svg
                    width="7"
                    height="12"
                    viewBox="0 0 7 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M6.467.719a.41.41 0 0 0 .126-.3.387.387 0 0 0-.126-.293A.387.387 0 0 0 6.174 0a.41.41 0 0 0-.3.126L0 6l5.874 5.881c.084.08.184.119.3.119.117 0 .214-.04.293-.119a.41.41 0 0 0 .126-.3.387.387 0 0 0-.126-.293L1.187 6 6.466.719Z"
                        fill="#17299B"
                    />
                </svg>
            </button>
            <img
                :src="require('@/assets/icons/' + logo + '.svg')"
                :alt="`${logo} 'icon'`"
                loading="lazy" 
                decoding="async"
            />
            <figcaption>{{ title }}</figcaption>
        </figure>
        <button @click="handleCloseIframe" :class="{ hidden: adaptStateToDevice() }" type="button" class="payment__close">{{translate("ui.cancel.btn","Cancel")}}</button>
    <!-- <div class="mobile__email">
            {{ customer.email }}
        </div> -->
    </article>
</template>
<script>
import { ref, onBeforeUnmount, computed } from "vue";
import { injectStore, mapState } from "redux-vuex";
import { getValueFromPath } from "@/support/helpers";
export default {
    name: "MobileHeader",
    components: {},
    props: {
        title: {
            type: String,
            required: true,
        },
        customer: {
            type: Object,
            required: true,
        },
        method: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const closeClass = computed(() => {
            return checkoutData.value.view.context.hasBackAction ? "has-close" : "no-close";
        });
        const logo = computed(() => {
            let newLogo = "";
            switch (props.method) {
            case "mobilemoneyghana":
                newLogo = "mobilemoney";
                break;
            case "mpesa":
                newLogo = "mobilemoney";
                break;
            case "mobilemoneyuganda":
                newLogo = "mobilemoney";
                break;
            case "mobilemoneymalawi":
                newLogo = "mobilemoney";
                break;
            case "mobilemoneyrwanda":
                newLogo = "mobilemoney";
                break;
            case "mobilemoneyzambia":
                newLogo = "mobilemoney";
                break;
            case "mobilemoneytanzania":
                newLogo = "mobilemoney";
                break;
            case "mobilemoneyfranco":
                newLogo = "mobilemoney";
                break;
            default:
                newLogo = props.method;
                break;
            }
            return newLogo;
        });
        const store = injectStore();
        const checkoutData = ref(store.getState());
        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });
        onBeforeUnmount(() => {
            subscription();
        });
        function goBack() {
            checkoutData.value.view.context.$actions.back();
        }
        function handleCloseIframe(state) {
            store.Control.close(state);
        }
        return {
            state: mapState({
                back: (state) => getValueFromPath(state, "view.current") || null,
                hasBack: (state) =>
                    getValueFromPath(state, "view.context.hasBackAction") || false,
            }),
            logo,
            handleCloseIframe,
            goBack,
            closeClass,
        };
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
article,
figure {
  display: none;
  @media screen and (max-width: $breakpoint-middle * 1px) {
    display: flex;
    align-items: center;
  }
}
figure {
  margin: 0;
  @media screen and (max-width: $breakpoint-middle * 1px) {
    display: flex;
    align-items: center;
  }
}
.mobile__payment-header {
  background: #F2F2F2;
  @media screen and (max-width: $breakpoint-middle * 1px) {
    display: flex;
    padding: 1.5rem 2.2rem 1.5rem 0.7rem;
    margin-bottom: 2.4rem;
    /* padding-top: 1rem; */
    justify-content: space-between;
    /* border-bottom: 1px solid #ebebeb; */
    align-items: center;
  }
}
figcaption {
  font-size: 1.4rem;
  line-height: 1.5rem;
  margin-left: 1rem;
  text-transform: capitalize;
  font-weight: 600;
  color: #333333;
}
.mobile__email {
  font-size: 1.176rem;
  font-weight: $font-light;
  line-height: 1.6rem;
  text-align: right;
  color: $secondary-color;
  width: 50%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  @media screen and (min-width: 576px) {
    display: none;
  }
}
img {
  width: 30px;
  padding-left: 5px;
  @include screen(small) {
    width: 22px;
  }
  width: 30px;
  padding-left: 5px;
}
.transfer {
  width: 15px;
}
.has-close {
    margin-right: 0.6rem;
}
.no-close {
    visibility: hidden;
    margin-left: -2.2rem;
}
.payment__close {
        position: relative;
        // background: $white;
        border: none;
        padding: 0;
        font-size: 1.4rem;
        line-height: 1.6rem;
        color: $red;
        margin: 0;
        font-weight: $font-semi-bold;
  }
</style>